import { FormikValues } from 'formik';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { WizardStepProps } from './types';
import ErrorBoundary from '../../ErrorBoundary';
import { ai } from '../../../instrumentation/AppInsightsService';

const WizardStep = <T extends FormikValues>(props: WizardStepProps<T>) => {
    const {
        children,
    } = props;

    return <ErrorBoundary appInsights={ai.reactPlugin as ReactPlugin}>{children}</ErrorBoundary>;
};

export default WizardStep;
